import React from 'react';
import { Bar } from 'react-chartjs-2';
import 'chart.js/auto';

export default function SalesBySeller(props: any) {
  const { salesBySeller = [] } = props;
  
  const barData = {
    labels: salesBySeller.map((seller: any) => seller.seller_name),
    datasets: [
      {
        label: 'Ventas ($)',
        data: salesBySeller.map((seller: any) => seller.total_sales),
        backgroundColor: 'rgba(75, 192, 192, 0.6)',
        barPercentage: 1.0, // máximo ancho dentro del grupo
        categoryPercentage: 0.1, // máximo espacio para los grupos
        yAxisID: 'y',
      },
      {
        label: 'Pedidos',
        data: salesBySeller.map((seller: any) => seller.total_orders),
        backgroundColor: 'rgba(153, 102, 255, 0.6)',
        barPercentage: 1.0, // máximo ancho dentro del grupo
        categoryPercentage: 0.1, // máximo espacio para los grupos
        yAxisID: 'y1', // Eje secundario
      },
    ],
  };

  const options = {
    responsive: true,
    scales: {
      y: {
        type: 'linear' as const,
        display: true,
        position: 'left' as const,
        title: {
          display: true,
          text: 'Ventas ($)',
        },
      },
      y1: {
        type: 'linear' as const,
        display: true,
        position: 'right' as const,
        title: {
          display: true,
          text: 'Pedidos',
        },
        grid: {
          drawOnChartArea: false, // solo líneas del eje izquierdo
        },
      },
    },
  };

  return (
    <div className="bar-chart">
        <Bar 
            data={barData}
            options={options}
        />
    </div>
  );
}
